// extracted by mini-css-extract-plugin
export default {"icon":"BannedInfo-icon-e369fbdccbd4c72c18750d2d8703b35b"};